<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <SectionLayout :settings="fields.settings" :container-page="fields.containerPage" />

        <!-- Title Card -->
        <div class="mb-5">
          <label class="label-input">Title Section</label>
          <div class="group-item">
            <v-checkbox v-model="fields.cardTitle.show" label="Show title block" hide-details class="mt-0 mb-2" />
            <ckeditor
              v-if="fields.cardTitle.show"
              :editor="editor"
              v-model="fields.cardTitle.content"
              :config="editorConfig"
            />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Highlight Color</label>
          <div class="group-item">
            <ColorPicker
              :value="fields.highlightColor"
              name="highlight-color"
              label="Highlight Color"
              default-color="#AD4870"
              @input="value => (fields.highlightColor = value)"
            />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Product Actions</label>
          <div class="group-item">
            <v-checkbox
              v-model="fields.showActions"
              label="Show view product & add to cart icons"
              hide-details
              class="mt-0"
            />
          </div>
        </div>

        <!-- Products -->
        <!--
          CHỈ 1 danh sách sản phẩm duy nhất: cùng data này được render lặp lại cho khối
          desktop (grid) và khối mobile (swiper slide) khi Save, không có field desktop/mobile
          riêng trong editor.
        -->
        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Products</label>
            <v-btn small color="primary" @click="handleAddProduct">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Product</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(product, idx) in fields.products" :key="`product-${idx}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Product {{ idx + 1 }} - {{ product.price || '' }}</span>
                    <v-btn
                      icon
                      :disabled="fields.products.length <= MIN_PRODUCT_ITEMS"
                      @click.stop="handleRemoveProduct(idx)"
                    >
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="sub-block">
                    <div class="d-flex justify-space-between align-center mb-2">
                      <label class="mb-0">Images (max {{ MAX_IMAGE_ITEMS }}) - ảnh 2 dùng để hover đổi ảnh</label>
                      <v-btn
                        small
                        color="primary"
                        :disabled="product.images.length >= MAX_IMAGE_ITEMS"
                        @click="handleAddImage(product)"
                      >
                        <v-icon size="16">mdi-plus</v-icon>
                        <span>Add Image</span>
                      </v-btn>
                    </div>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                        v-for="(image, imgIdx) in product.images"
                        :key="`product-image-${imgIdx}`"
                      >
                        <div class="d-flex justify-space-between align-center mb-2">
                          <label class="mb-0">Image {{ imgIdx + 1 }}</label>
                          <v-btn
                            icon
                            x-small
                            :disabled="product.images.length <= MIN_IMAGE_ITEMS"
                            @click="handleRemoveImage(product, imgIdx)"
                          >
                            <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                          </v-btn>
                        </div>
                        <UploadImage
                          :image="{ imageSrc: image }"
                          :height="`220`"
                          :typeUpload="'image'"
                          @callback="obj => handleSetProductImage(product, imgIdx, obj.imageSrc)"
                          @callbackDelete="handleSetProductImage(product, imgIdx, '')"
                        />
                      </v-col>
                    </v-row>
                  </div>

                  <div class="sub-block">
                    <label>Link</label>
                    <v-text-field v-model="product.link" hide-details class="mt-0" />
                  </div>

                  <div class="sub-block">
                    <label>Product Title (HTML)</label>
                    <ckeditor :editor="editor" v-model="product.title" :config="editorConfig" />
                  </div>

                  <div class="sub-block">
                    <label>Price</label>
                    <v-row>
                      <v-col cols="12" md="6">
                        <label>Price</label>
                        <v-text-field v-model="product.price" hide-details class="mt-0" />
                      </v-col>
                      <v-col cols="12" md="6">
                        <label>Old Price</label>
                        <v-text-field v-model="product.oldPrice" hide-details class="mt-0" />
                      </v-col>
                    </v-row>
                  </div>

                  <div class="sub-block">
                    <v-checkbox v-model="product.state.show" label="Show state badge" hide-details class="mt-0 mb-2" />
                    <v-text-field
                      v-if="product.state.show"
                      v-model="product.state.text"
                      label="State text (New, Sale...)"
                      hide-details
                      class="mt-0"
                    />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <!-- Btn Primary -->
        <div class="mb-5">
          <label class="label-input">Primary Button</label>
          <div class="group-item">
            <ButtonPrimary :button="fields.buttonOutSide" />
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import ButtonPrimary from '../common/ui-modules/button-primary/editor.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';
import ColorPicker from '../common/ui-modules/inputs/color-picker.vue';

const MIN_PRODUCT_ITEMS = 1;
// Mỗi sản phẩm tối đa 2 ảnh: ảnh 1 hiển thị mặc định, ảnh 2 dùng để đổi khi hover.
const MAX_IMAGE_ITEMS = 2;
const MIN_IMAGE_ITEMS = 1;

const buildButtonAreaDefault = () => ({
  align: 'center',
  backgroundColor: '#606F99',
  color: '#FFFFFF',
  radius: 4,
  iconPrefix: { show: false, src: '' },
  iconSuffix: { show: false, src: '' },
  text: 'VIEW ALL',
  link: '#',
  show: true,
  subBtn: { show: false, text: '' },
  policy: { show: false, colPerView: 2, alignContent: 'center', items: [] },
});

const buildProductItemDefault = () => ({
  link: '#',
  images: [''],
  state: { show: true, text: 'New' },
  title: '<h3>Product name</h3>',
  price: '$0.00',
  oldPrice: '',
});

const getDefaultFields = () => ({
  title: 'Calyrafit Best Seller Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: true,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  cardTitle: {
    show: true,
    content: '<h2>BEST SELLER</h2><p>Lorem ipsum dolor sit amet consectetur,</p>',
  },
  highlightColor: '#AD4870',
  showActions: true,
  products: [buildProductItemDefault()],
  buttonOutSide: buildButtonAreaDefault(),
});

// Chuẩn hoá tối đa MAX_IMAGE_ITEMS ảnh / sản phẩm, luôn có ít nhất 1 phần tử để bind UploadImage.
const normalizeProductImages = images => {
  const list = Array.isArray(images) && images.length ? images.slice(0, MAX_IMAGE_ITEMS) : [''];
  return list;
};

export default {
  name: 'CalyrafitBestSallerSectionEditor',
  components: { UploadImage, ButtonPrimary, SectionLayout, ColorPicker },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      MIN_PRODUCT_ITEMS,
      MAX_IMAGE_ITEMS,
      MIN_IMAGE_ITEMS,
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = cloneDeep(this.sectionEditor.sectionExtract || {});

    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
      cardTitle: { ...def.cardTitle, ...(extract.cardTitle || {}) },
      buttonOutSide: { ...def.buttonOutSide, ...(extract.buttonOutSide || {}) },
      products:
        Array.isArray(extract.products) && extract.products.length
          ? extract.products.map(product => ({
              ...buildProductItemDefault(),
              ...product,
              state: { ...buildProductItemDefault().state, ...(product.state || {}) },
              images: normalizeProductImages(product.images),
            }))
          : def.products,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        products: this.fields.products.map(product => ({
          ...product,
          images: normalizeProductImages(product.images),
        })),
      };
      const updateHtml = updateHtmlFromData.sectionCalyrafitBestSaller(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddProduct() {
      this.fields.products.push(cloneDeep(buildProductItemDefault()));
    },
    handleRemoveProduct(idx) {
      if (this.fields.products.length <= MIN_PRODUCT_ITEMS) return;
      this.fields.products.splice(idx, 1);
    },
    handleAddImage(product) {
      if (product.images.length >= MAX_IMAGE_ITEMS) return;
      product.images.push('');
    },
    // Gán trực tiếp product.images[imgIdx] = value KHÔNG reactive trong Vue 2 (Vue không theo
    // dõi được set theo index) -> UploadImage sẽ không re-render ảnh vừa upload. Phải dùng $set.
    handleSetProductImage(product, imgIdx, value) {
      this.$set(product.images, imgIdx, value);
    },
    handleRemoveImage(product, imgIdx) {
      if (product.images.length <= MIN_IMAGE_ITEMS) return;
      product.images.splice(imgIdx, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.sub-block {
  border-top: 1px dashed #0000001a;
  padding-top: 12px;
  margin-top: 12px;
}
.ck-editor__editable_inline,
.ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
